import { HighlightText, Typography } from "@codat/orchard-ui";
import React from "react";

import styles from "../CompaniesTable/CompaniesTable.module.scss";

export type CreatedCellModel = {
  key: "created";
  value: {
    createdByUser: string;
    createdDate: string;
    searchQuery?: string;
    hideCell?: boolean;
  };
};

export function CreatedCell({ value }: Pick<CreatedCellModel, "value">) {
  if (value.hideCell) return <></>;
  return (
    <>
      <Typography
        as="div"
        className={styles.createdDate}
        data-testid="companies-table-createdby"
        variant="body_sm"
      >
        <HighlightText search={value.searchQuery}>
          {value.createdDate}
        </HighlightText>
      </Typography>
      <Typography
        as="div"
        className={styles.createdBy}
        data-testid="companies-table-createdByUser"
        variant="body_xs"
        title={`By ${value.createdByUser}`}
      >
        {`By ${value.createdByUser}`}
      </Typography>
    </>
  );
}
